// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { AnimatePresence } from 'framer-motion';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useRef } from 'react';
import './DreamModalItems.module.scss';
// =========================

export default function DreamModalItems({
  items,
  title,
  itemLength,
  addModal,
}: {
  items: React.ReactNode;
  title: string;
  itemLength: number;
  addModal?: React.ReactNode;
}) {
  const translate = useTranslate();
  const { setModal } = useRootModal();

  const ref = useRef(null);

  return (
    <div>
      <div styleName="top">
        <h3 styleName="heading">{translate(title)}</h3>
        <ArrowButtons reference={ref} />
      </div>
      <div styleName="item-container">
        <div styleName="item-wrapper" ref={ref}>
          {!!itemLength && (
            <div styleName="items">
              <AnimatePresence>{items}</AnimatePresence>
            </div>
          )}
        </div>
        {!!addModal && (
          <CircleButton
            icon={faPlus}
            color="grey-blue"
            onClick={() => setModal(addModal)}
          />
        )}
      </div>
    </div>
  );
}
